import React, { useContext } from "react";
import { Spinner } from "reactstrap";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { getUserInfoFromSession } from "../../adapters/session/localSessionAdapter";
import { updateStorageItemsAPI } from "../../adapters/dashboard/dashboardAdapater";
import DashboardContext from "../../context/dashboard/DashboardContext";
import { ConfirmCancel } from "../modal/dashboard/ConfirmCancel";

export function StorageItems(props) {
  const { items, estimateId, editDisabled } = props;
  const { register, handleSubmit, errors } = useForm();
  const [showEdit, setShowEdit] = useState(false);
  const [error, setError] = useState(null);
  const [progress, setProgress] = useState(false);
  const [confirmCancel, setConfirmCancel] = useState(false);
  const context = useContext(DashboardContext);

  const submitFn = async (data) => {
    setProgress(true);
    const userSession = getUserInfoFromSession();
    const userId = userSession["userId"];
    let body = {
      estimate_id: estimateId,
      user_id: userId,
      storage_items: data["storage_items"],
    };

    try {
      const res = await updateStorageItemsAPI(body);
      if (res.data.meta.code === 200 && res.data.meta.status === "OK") {
        //successfully updated.
        setProgress(false);
        setShowEdit(false);
        setConfirmCancel(false);
        context.updateStatus({
          status: "success",
          color: "success",
          message: "Inventory Details Updated Successfully!",
        });
        context.refresh();
      } else {
        context.updateStatus({
          status: "error",
          color: "danger",
          message: "An Error Occurred!",
        });
        setProgress(false);
        setError("An Error Occurred");
      }
    } catch (e) {
      setProgress(false);
      setError("An Error Occurred");
      console.error("An Error occurred", e);
    }
  };
  const JSX = (
    <div className="storage-list-container">
      <div className="d-flex flex-row align-items-center justify-content-between my-4">
        <h3 className="m-0 mr-2">Inventory Details</h3>
        {editDisabled === false && showEdit === false && (
          <button
            className="btn btn-dark btn-sm"
            onClick={() => {
              setShowEdit(true);
            }}
          >
            Edit Inventory
          </button>
        )}
      </div>
      {showEdit === false && (
        <div className="border rounded border-danger my-4 p-3">{items}</div>
      )}
      {showEdit === true && (
        <div className="border rounded border-danger my-4 p-3">
          <form onSubmit={handleSubmit(submitFn)}>
            <textarea
              ref={register({
                validate: {
                  isRequired: (value) => value.trim().length !== 0,
                },
              })}
              rows={5}
              className="form-control"
              name="storage_items"
              id="storage_items"
              placeholder="Ex:TV - 1,
              Washing Machine - 1,
              Double cot (dismantable /box type),
              Sofa 3+1+1"
            >
              {items}
            </textarea>
            <span className="error-text">
              {errors.storage_items &&
                errors.storage_items.type === "isRequired" &&
                "This field is required."}
            </span>
            {error !== null && <div className="error-text">{error}</div>}

            <div className="d-flex mt-2 justify-content-center">
              <button
                type="submit"
                disabled={progress === true ? true : false}
                className="btn btn-sm btn-primary"
              >
                {progress === true && (
                  <>
                    {" "}
                    <Spinner size={"sm"} /> Saving{" "}
                  </>
                )}
                {progress === false && <> Save </>}
              </button>
              <button
                className="btn btn-dark btn-sm ml-2"
                onClick={() => {
                  setConfirmCancel(true);
                }}
                type="button"
                disabled={progress === true ? true : false}
              >
                Back
              </button>
            </div>
          </form>
          <ConfirmCancel
            onYes={() => {
              handleSubmit(submitFn)();
            }}
            progress={progress}
            onNo={() => {
              setShowEdit(false);
              setConfirmCancel(false);
            }}
            modal={confirmCancel}
            promptText={
              "Storage items details has not been saved. Do you want to save?"
            }
          />
        </div>
      )}
    </div>
  );
  return JSX;
}
